import { useState } from 'react';
import { Button, Select } from 'antd';
import { SortAscendingOutlined } from '@ant-design/icons';
import { radius } from '../theme/tokens';
import type { FieldLike } from './types';

export interface SortAddPopoverProps {
  fields: FieldLike[];
  onAdd: (slug: string, dir: 'asc' | 'desc') => void;
  onCancel: () => void;
}

export function SortAddPopover({ fields, onAdd, onCancel }: SortAddPopoverProps): JSX.Element {
  const [fieldSlug, setFieldSlug] = useState<string | null>(null);
  const [direction, setDirection] = useState<'asc' | 'desc'>('asc');

  return (
    <div className="lens-sort-add">
      <span className="lens-sort-add__hint">
        <SortAscendingOutlined style={{ fontSize: 12 }} />
        Сортировать
      </span>
      <Select
        size="small"
        style={{ width: 160 }}
        placeholder="Поле"
        value={fieldSlug}
        onChange={setFieldSlug}
        options={fields.map((f) => ({ value: f.slug, label: f.name }))}
        showSearch
        filterOption={(input, opt) =>
          (opt?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
        }
      />
      <Select
        size="small"
        style={{ width: 120 }}
        value={direction}
        onChange={setDirection}
        options={[
          { value: 'asc', label: 'По возр.' },
          { value: 'desc', label: 'По убыв.' },
        ]}
      />
      <Button
        size="small"
        type="primary"
        disabled={!fieldSlug}
        onClick={() => fieldSlug && onAdd(fieldSlug, direction)}
        style={{ borderRadius: radius.md }}
      >
        Добавить
      </Button>
      <Button size="small" onClick={onCancel} style={{ borderRadius: radius.md }}>
        Отмена
      </Button>
    </div>
  );
}
